import { studyCountries, skilledMigration, digitalNomad, visitVisas, accommodation, WHATSAPP_URL, WHATSAPP_URL_VISIT, PHONE_VISIT } from '../data/siteData';
import { PageHero, CTASection } from '../components/UI';
import { useState } from 'react';

const SvcTabIcon = ({ type }) => {
  const icons = {
    study:    <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M12 14l9-5-9-5-9 5 9 5z"/><path d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z"/></svg>,
    skilled:  <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 21V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v16"/></svg>,
    nomad:    <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8M12 17v4"/></svg>,
    visit:    <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.8a19.79 19.79 0 01-3.07-8.68A2 2 0 012 .18h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/></svg>,
    acc:      <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>,
  };
  return icons[type] || null;
};

const tabs = [
  { id: 'study',   label: 'Study Abroad (35 countries)' },
  { id: 'skilled', label: 'Skilled Migration' },
  { id: 'nomad',   label: 'Digital Nomad Visa' },
  { id: 'visit',   label: 'Visit Visa' },
  { id: 'acc',     label: 'Accommodation' },
];

export default function Services({ setPage }) {
  const [activeTab, setActiveTab] = useState('study');
  const wa = (ctx) => window.open(`https://wa.me/923084715628?text=Hi, I want to enquire about ${encodeURIComponent(ctx)}`, '_blank');

  return (
    <div>
      <PageHero breadcrumb="Services" title="All Services. One Team." subtitle="Five complete service categories — covering every step of your journey abroad." />

      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          {/* Tab nav */}
          <div className="flex flex-wrap gap-2 mb-10">
            {tabs.map(t => (
              <button key={t.id} onClick={() => setActiveTab(t.id)}
                className={`inline-flex items-center gap-2 text-sm font-semibold px-4 py-2.5 rounded-full border transition-all duration-200 ${activeTab === t.id ? 'bg-teal/12 border-teal text-teal' : 'bg-transparent border-gray-200 text-gray-500 hover:border-teal/40 hover:text-teal'}`}>
                <SvcTabIcon type={t.id} />
                {t.label}
              </button>
            ))}
          </div>

          {/* STUDY */}
          {activeTab === 'study' && (
            <div>
              <p className="text-sm text-gray-500 leading-relaxed mb-6 px-4 py-3 bg-teal/5 border-l-4 border-teal rounded-r-xl">University selection, admission, Statement of Purpose, financial documentation, and student visa — full end-to-end support across 35 countries. Click any country to enquire on WhatsApp.</p>
              <div className="grid grid-cols-3 sm:grid-cols-5 lg:grid-cols-9 gap-2">
                {studyCountries.map(d => (
                  <button key={d.name} onClick={() => wa(`Study in ${d.name}`)}
                    className="bg-gray-50 border border-gray-100 rounded-xl p-3 text-center hover:border-teal hover:bg-teal/5 hover:-translate-y-1 transition-all duration-200 cursor-pointer">
                    <div className="text-2xl mb-1">{d.flag}</div>
                    <div className="font-body font-semibold text-navy text-[0.7rem] leading-tight">{d.name}</div>
                    <div className="text-[0.6rem] text-teal mt-0.5">{d.tag}</div>
                  </button>
                ))}
              </div>
            </div>
          )}

          {/* SKILLED */}
          {activeTab === 'skilled' && (
            <div>
              <p className="text-sm text-gray-500 leading-relaxed mb-6 px-4 py-3 bg-teal/5 border-l-4 border-teal rounded-r-xl">Work and settle abroad through points-based and employer-sponsored pathways. We handle full profile assessment, points calculation, and the complete application process.</p>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {skilledMigration.map(m => (
                  <div key={m.country} onClick={() => wa(`${m.visa}`)} className="bg-gray-50 border border-gray-100 rounded-2xl p-6 hover:border-teal hover:-translate-y-1 transition-all duration-300 cursor-pointer group relative overflow-hidden">
                    <div className="absolute top-0 left-0 right-0 h-[2px] bg-gradient-to-r from-teal to-teal-light scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"></div>
                    <div className="flex items-center gap-3 mb-3">
                      <span className="text-2xl">{m.flag}</span>
                      <span className="font-body font-bold text-navy">{m.country}</span>
                    </div>
                    <div className="text-xs font-semibold text-teal mb-3">{m.visa}</div>
                    <p className="text-gray-500 text-xs leading-relaxed mb-4">{m.desc}</p>
                    <span className="text-xs font-bold text-teal">{m.cta}</span>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* DIGITAL NOMAD */}
          {activeTab === 'nomad' && (
            <div>
              <p className="text-sm text-gray-500 leading-relaxed mb-6 px-4 py-3 bg-teal/5 border-l-4 border-teal rounded-r-xl">Live anywhere in the world while working remotely. Digital nomad visas let you stay legally in a country while earning from overseas clients or employers.</p>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                {digitalNomad.map(n => (
                  <button key={n.name} onClick={() => wa(`Digital Nomad Visa ${n.name}`)}
                    className="bg-gray-50 border border-gray-100 rounded-xl p-5 text-left flex items-center gap-4 hover:border-teal hover:bg-teal/5 hover:-translate-y-1 transition-all duration-200">
                    <span className="text-3xl flex-shrink-0">{n.flag}</span>
                    <div>
                      <div className="font-body font-bold text-navy text-sm">{n.name}</div>
                      <div className="text-[0.7rem] text-gray-400 mt-0.5">{n.sub}</div>
                    </div>
                  </button>
                ))}
              </div>
            </div>
          )}

          {/* VISIT VISA */}
          {activeTab === 'visit' && (
            <div>
              <p className="text-sm text-gray-500 leading-relaxed mb-6 px-4 py-3 bg-teal/5 border-l-4 border-teal rounded-r-xl">Family visits, tourism, medical travel, and business trips. We prepare a complete, tailored application that gives you the strongest possible chance of approval.</p>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
                {visitVisas.map(v => (
                  <button key={v.name} onClick={() => window.open(WHATSAPP_URL_VISIT + `?text=Hi, I want to enquire about ${encodeURIComponent(v.name)} Visit Visa`, '_blank')}
                    className="bg-gray-50 border border-gray-100 rounded-xl p-4 text-left flex items-center gap-4 hover:border-teal hover:bg-teal/5 hover:-translate-y-1 transition-all duration-200">
                    <span className="text-2xl flex-shrink-0">{v.flag}</span>
                    <div>
                      <div className="font-body font-bold text-navy text-sm">{v.name}</div>
                      <div className="text-[0.72rem] text-gray-400 mt-0.5">{v.type}</div>
                    </div>
                  </button>
                ))}
              </div>
              {/* Special visit visa call banner */}
              <div className="flex items-center justify-between flex-wrap gap-4 bg-teal/7 border border-teal/25 rounded-2xl p-6">
                <div>
                  <div className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-1">Dedicated Visit Visa Enquiry Line</div>
                  <div className="font-bold text-navy text-lg">For all visit visa queries, call or WhatsApp:</div>
                  <div className="flex gap-6 mt-2 flex-wrap">
                    <a href={`tel:0${PHONE_VISIT.replace(/\s/g,'')}`} className="text-teal font-bold text-lg hover:underline">📞 {PHONE_VISIT}</a>
                    <a href={WHATSAPP_URL_VISIT} target="_blank" rel="noreferrer" className="text-[#25D366] font-semibold text-sm hover:underline">WhatsApp {PHONE_VISIT}</a>
                  </div>
                </div>
                <a href={WHATSAPP_URL_VISIT + '?text=Hi, I want to enquire about a Visit Visa'} target="_blank" rel="noreferrer"
                  className="flex items-center gap-2 bg-[#25D366] text-white font-bold text-sm px-5 py-3 rounded-xl hover:bg-green-500 transition-colors">
                  💬 Enquire Now
                </a>
              </div>
            </div>
          )}

          {/* ACCOMMODATION */}
          {activeTab === 'acc' && (
            <div>
              <p className="text-sm text-gray-500 leading-relaxed mb-6 px-4 py-3 bg-teal/5 border-l-4 border-teal rounded-r-xl">Verified, safe housing found before you arrive — student halls, shared apartments, and family homes across 13 countries. No arriving abroad without somewhere to stay.</p>
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
                {accommodation.map(a => (
                  <button key={a.name} onClick={() => wa(`Accommodation in ${a.name}`)}
                    className="bg-gray-50 border border-gray-100 rounded-xl p-4 text-left flex items-center gap-3 hover:border-teal hover:bg-teal/5 hover:-translate-y-1 transition-all duration-200">
                    <span className="text-xl flex-shrink-0">{a.flag}</span>
                    <div>
                      <div className="font-body font-bold text-navy text-sm">{a.name}</div>
                      <div className="text-[0.65rem] text-gray-400 mt-0.5">{a.sub}</div>
                    </div>
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>
      </section>

      <CTASection title="Ready to Get Started?" subtitle="Book a free consultation. We'll tell you your real chances before you commit to anything." setPage={setPage} />
    </div>
  );
}
